// extracted by mini-css-extract-plugin
export default {"wrapper":"ConvertedFrom_wrapper__xhOrH","highlighted":"ConvertedFrom_highlighted__CD7PP"};